import * as React from "react";
import {FC} from "react";
import * as R from "ramda";
import {withMenu} from "../../../reactutils/withMenu";
import {MenuSysAdmin} from "../../MenuSysAdmin";
import {withBorder} from "../../../reactutils/withBorder";
import {SysAdminSystemSubMenu} from "../SysAdminSubMenu";
import {withTitle} from "../../../reactutils/withTitle";
import {withLogin} from "../../../reactutils/withLogin";
import {useDbChangesApi} from "../../System/systemConfig";
import {useQuery} from "@tanstack/react-query";
import {Table} from "reactstrap";
import {DateTime} from "../../DateTime";

const DbChanges: FC = () => {

    const api = useDbChangesApi();

    const dbChangesQuery = useQuery({
        queryKey: ['dbChanges'],
        queryFn: () => api.getDatabaseChanges(),
    })
    return <div>
        <Table>
            <thead></thead>
            <tbody>
            {dbChangesQuery.data?.map((dc) => <React.Fragment key={dc.name}>
                <tr key={dc.name} className="fw-bold">
                    <td>{dc.name}</td>
                    <td><DateTime date={dc.dateTime}/></td>
                </tr>
                {dc.changes?.map((c, idx) => <tr key={idx}>
                    <td colSpan={2} className="ps-3">{c.statement}</td>
                </tr>)}
            </React.Fragment>)}
            </tbody>
        </Table>
    </div>;

}

export const DbChangesComp = R.compose(
    withMenu(<MenuSysAdmin/>),
    withBorder(),
    withMenu(<SysAdminSystemSubMenu/>),
    withTitle('DB Changes'),
    withLogin(),
)(DbChanges);